export enum FulfillmentMethod {
  PickUp = 'Pick Up',
  Curbside = 'Curbside',
}
